import { CircularProgress } from '@components/core-ui/spinners/CircularProgress';

export const CircularProgressDemo = () => (
  <div className="flex flex-col gap-4">
    <p className="text-xs text-foreground-muted">
      Progress ring (not a spinner). Used in Jobs report % and job audio quality score.
    </p>
    <div className="flex flex-wrap items-center gap-6">
      <CircularProgress
        progress={65}
        size={20}
        trackWidth={3}
        indicatorWidth={3}
        rotate={-90}
        trackColor="var(--color-tint)"
        indicatorColor="var(--color-text-muted)"
      />
      <CircularProgress
        progress={75}
        size={80}
        rotate={-90}
        trackColor="var(--color-border)"
        indicatorColor="var(--color-accent)"
      />
    </div>
  </div>
);
